// extracted by mini-css-extract-plugin
export default {"studentPanel":"StudentPanel_studentPanel__uOM1Y","searchControl":"StudentPanel_searchControl__I4J7l","memTable":"StudentPanel_memTable__d4GPt"};